import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  GeoAlt,
  Telephone,
  Envelope,
  Instagram,
  Tiktok,
  ArrowRightShort,
  Facebook,
  Youtube,
  ChatQuote,
} from "react-bootstrap-icons";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-saas mt-5" role="contentinfo">
      <div className="footer-line" aria-hidden="true"></div>

      <Container className="pt-5 pb-4">
        <Row className="gy-5">
          {/* Spalte 1: Branding (Breite: 4 von 12) */}
          <Col lg={4} md={12} className="text-center text-lg-start">
            <h4 className="fw-bold mb-3 text-white brand-title">
              BBS <span className="text-green-bbs">2</span> Leer
            </h4>
            <p className="text-bbs-gray small pe-lg-4 lh-lg">
              Dein Partner für berufliche Bildung in Ostfriesland. Wir begleiten
              dich von der ersten Orientierung bis zum höchsten Schulabschluss.
            </p>
            <div
              className="social-wrapper pt-3"
              role="group"
              aria-label="Soziale Netzwerke"
            >
              <a
                href="https://www.facebook.com/bbs2leer"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Besuche unsere BBS 2 Leer auf Facebook"
                className="social-icon facebook-footer"
              >
                <Facebook />
              </a>
              <a
                href="https://www.instagram.com/bbs2leer"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Besuche unsere BBS 2 Leer auf Instagram"
                className="social-icon instagram-footer"
              >
                <Instagram />
              </a>
              <a
                href="https://www.tiktok.com/@bbs2leer"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Besuche unsere BBS 2 Leer auf TikTok"
                className="social-icon tiktok-footer"
              >
                <Tiktok />
              </a>
              <a
                href="https://www.youtube.com/channel/UC-8-ii9B_PY1-3PJ1MdxPBA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Besuche unsere BBS 2 Leer auf YouTube"
                className="social-icon youtube-footer"
              >
                <Youtube />
              </a>
            </div>
            <div
              className="footer-support-notice mt-4 mb-3 p-3 rounded text-start"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                borderLeft: "3px solid #28a745",
              }}
            >
              <div className="d-flex align-items-start gap-3">
                <ChatQuote
                  size={18}
                  className="flex-shrink-0 mt-1"
                  style={{ color: "#28a745" }}
                  aria-hidden="true"
                />
                <span className="small text-bbs-gray">
                  Wenn du Ängste hast, dir Sorgen machst oder sonstige Unterstützung brauchst,
                  melde dich bitte gerne bei unserem {" "}
                  <Link
                    to="/schoollife/beratungsteam"
                    className="text-white text-decoration-underline fw-bold"
                    style={{ transition: "color 0.2s" }}
                  >
                    Beratungsteam
                  </Link>
                  .
                </span>
              </div>
            </div>
          </Col>

          {/* Spalte 2: Bildungsziele / Links (Breite: 4 von 12, rückt durch ps-lg-5 elegant ein) */}
          <Col lg={4} md={6} className="ps-lg-5">
            <h2 className="footer-heading h6 fw-bold mb-2">Bildungsziele</h2>
            <nav aria-label="Footer Quicklinks">
              <ul className="list-unstyled footer-links">
                <li>
                  <Link to="/angebot/dual">
                    <ArrowRightShort aria-hidden="true" /> Berufsausbildung
                  </Link>
                </li>
                <li>
                  <Link to="/angebot/aufstieg">
                    <ArrowRightShort aria-hidden="true" /> (Fach-) Abitur /
                    Techniker
                  </Link>
                </li>
                <li>
                  <Link to="/angebot/qualifizierung">
                    <ArrowRightShort aria-hidden="true" /> Ins Berufsleben
                    starten
                  </Link>
                </li>
                <li>
                  <Link to="/angebot/einstieg">
                    <ArrowRightShort aria-hidden="true" /> Einen Schulabschluss
                    machen
                  </Link>
                </li>
              </ul>
            </nav>
          </Col>

          <Col lg={4} md={6} className="ps-lg-4 text-center">
            {/* Teil A: Bürozeiten */}
            <h2 className="footer-heading h6 fw-bold text-center">
              Bürozeiten
            </h2>
            <div className="office-hours small text-bbs-gray mb-4 mt-2 d-inline-block text-start w-100 ms-3">
              {/* Sublabel in eigener Zeile */}
              <div className="text-white-50 fw-semibold mb-1">
                Montag bis Freitag:
              </div>
              {/* Uhrzeiten darunter - linksbündig */}
              <div className="text-white ps-2 border-start border-secondary">
                <div>07:30 - 10:00 Uhr</div>
                <div>10:30 - 12:00 Uhr</div>
              </div>
            </div>

            {/* Teil B: Kontakt direkt darunter */}
            <h2 className="footer-heading h6 fw-bold text-center">Kontakt</h2>
            <address className="contact-details font-style-normal small d-inline-block text-start w-100 ms-3 mt-2 border-start border-secondary ps-2">
              {/* Adresse */}
              <div className="contact-item">
                <div className="text-white-50 mb-1 d-flex align-items-center">
                  <GeoAlt
                    className="text-bbs-gray"
                    aria-hidden="true"
                    size={14}
                  />
                </div>
                <div className="text-white ps-1">Blinke 39, 26789 Leer</div>
              </div>

              {/* Telefon */}
              <div className="contact-item">
                <div className="text-white-50 mb-1 d-flex align-items-center">
                  <Telephone
                    className="text-bbs-gray"
                    aria-hidden="true"
                    size={14}
                  />
                </div>
                <div className="ps-1">
                  <a
                    href="tel:+4949192750"
                    className="text-white text-decoration-none"
                    aria-label="Telefon: 0 4 9 1. 9 2 7 5. 0"
                  >
                    0491 9275-0
                  </a>
                </div>
              </div>

              {/* E-Mail */}
              <div className="contact-item mb-0">
                <div className="text-white-50  d-flex align-items-center">
                  <Envelope
                    className="text-bbs-gray"
                    aria-hidden="true"
                    size={14}
                  />
                </div>
                <div className="ps-1">
                  <a
                    href="mailto:info@bbs2leer.de"
                    className="text-white text-decoration-none"
                    aria-label="E-Mail an info@bbs2leer.de schreiben"
                  >
                    info@bbs2leer.de
                  </a>
                </div>
              </div>
            </address>
          </Col>
        </Row>

        {/* Untere Bar (Unverändert, Rechtssicher verlinkt) */}
        <div className="footer-bottom border-top border-secondary mt-2 pt-2 d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="slogan-footer mb-3 mb-md-0" aria-hidden="true">
            MIT DER <span className="text-green-bbs">2</span> LERNT MAN BESSER!
          </div>
          <nav className="footer-legal" aria-label="Rechtliche Informationen">
            <Link to="/Imprint">Impressum</Link>
            <span className="mx-2" aria-hidden="true">
              •
            </span>
            <Link to="/DataProtection">Datenschutz</Link>
            <span className="mx-2" aria-hidden="true">
              •
            </span>
            <Link to="/AccessibilityStatement">Barrierefreiheit</Link>
            <span className="mx-2" aria-hidden="true">
              •
            </span>
            <Link to="https://bbs2leer.fan12.de/" target="_blank" rel="noopener noreferrer">Unser Fanshop</Link>
            <span className="mx-2" aria-hidden="true">
              •
            </span>
            <span className="opacity-50">© {currentYear} BBS 2 Leer</span>
          </nav>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
